module.exports = __webpack_public_path__ + "main/assets/public/subscribe-form/envelope.e8ad581892744363.svg";